import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'app-unauthorized-page',
  templateUrl: './unauthorized-page.component.html',
  standalone: false
})
export class UnauthorizedPageComponent {
  @HostBinding('class') class = 'd-flex f-1 w-100';
}
